import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b7930ea2: FaireBrandEntity = {
  token: "b_b7930ea2",
  type: "brand",
  name: "Small Adventure",
  avatarUrl:
    "https://cdn.faire.com/fastly/e824ea02cb009c90f55364089bc41ef0203b1fbd42b3f7503c7500e76beca5b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f9e0949c0740d6b8d159acaed9d82ebab7560da010fd3811009060f04db2650a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e824ea02cb009c90f55364089bc41ef0203b1fbd42b3f7503c7500e76beca5b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f9e0949c0740d6b8d159acaed9d82ebab7560da010fd3811009060f04db2650a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 43,
  isTopShop: true,
  isInsider: true,
  description:
    "Keiko Brodeur began making illustrated paper goods under the name Small Adventure in 2009 in order to explore being a self-taught illustrator after having graduated with a graphic design degree and working in a few different fields. She soon fell in love with creating illustrations for greeting cards and other products for her own small business. Small Adventure is located in a studio space in Los Angeles.\n\nThe aim of Small Adventure is to use illustration as a way to remind us all to connect back with the beauty around us and to be inspired by cultures and traditions that may be different from our own. We hope you enjoy each item we make!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:08.329Z",
    importedBy: "entity-db-cli",
  },
};
